import { createSlice } from '@reduxjs/toolkit';
import { CreateStagedShipmentState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { createStagedShipmentThunk } from './thunks';

// Initial State
const initialState: CreateStagedShipmentState = {
  errors: null,
  status: StoreStatus.IDLE,
  values: null,
  response: null,
};

// Slice
export const createStagedShipmentSlice = createSlice({
  name: 'shipment',
  initialState,
  reducers: {
    createStagedShipmentReset: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(createStagedShipmentThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });
    builder.addCase(createStagedShipmentThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
      state.values = null;
    });
    builder.addCase(createStagedShipmentThunk.rejected.type, (state, action: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = action.payload;
      state.response = null;
    });
  },
});

// Action creators
export const { createStagedShipmentReset } = createStagedShipmentSlice.actions;
export * from './thunks';
export default createStagedShipmentSlice.reducer;
